import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "../../../../../animations/worldcup/countrystadiums_video";
import PitchTactics from "../../_partials/PitchTactics/Index";

import assets from "./assets";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import countries from "../../../../../language/de/countries.json";
import { useTranslation } from "react-i18next";
import Image from "../../../../shared/components/Image";
import ImageOrVideo from "../../../../shared/components/ImageOrVideo/Index";
import {
  getDynamicLogoPath,
  toIsoDateString,
} from "../../../../shared/utils/functions";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/Index";
import arrowIn from "../../../assets/global/arrow-in.png";
import arrowOut from "../../../assets/global/arrow-out.png";
import parseMediaUrl from "../../../../shared/functions/parseMediaUrl";
import i18n from "i18next";

require("./style/style.scss");
require("./style/animation.scss");

const translations = {
  Group: "Gruppe",
};

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;
  const { t } = useTranslation();

  const lng = i18n?.language;

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const { options, fields, dynamic } = templateData;
  const color1 = getContentById("color1", options);
  const color2 = getContentById("color2", options);

  const headline = getContentById("headline", fields);

  const teamHome = _.get(dynamic, "assets.teamHome");
  const teamAway = _.get(dynamic, "assets.teamAway");
  // const nextGame = _.get(dynamic, "nextGame");
  const matchInfo = _.get(dynamic, "matchInfo");
  const lineups = _.get(dynamic, "lineup");
  // const teamDataStyles = _.get(teamData, "styles", {});

  const competitionId = matchInfo?.competition?.id;

  const thisGameDate = new Date(
    toIsoDateString(matchInfo?.date, matchInfo?.time),
  );

  const backgroundImage = getMainBackground(format, _.get(dynamic, "teamSide"));

  const homeTeam = _.find(matchInfo?.contestant, { position: "home" });
  const awayTeam = _.find(matchInfo?.contestant, { position: "away" });

  const teamSide = getContentById("selectedSide", fields);
  const kits = _.get(dynamic, "kits");

  const teamAlpha2 =
    teamSide === "home"
      ? getOptaCountryCode(homeTeam?.name, homeTeam?.shortName, homeTeam?.code)
      : getOptaCountryCode(awayTeam?.name, awayTeam?.shortName, awayTeam?.code);
  const teamId = teamSide === "home" ? homeTeam?.id : awayTeam?.id;
  const lineupData =
    teamSide === "home"
      ? _.find(lineups, { contestantId: homeTeam.id })
      : _.find(lineups, { contestantId: awayTeam.id });
  const formationUsed = lineupData?.formationUsed;
  const coach = lineupData?.teamOfficial?.firstName ? (
    <div>
      {lineupData?.teamOfficial?.shortFirstName}{" "}
      {lineupData?.teamOfficial?.shortLastName}
    </div>
  ) : (
    "-"
  );

  const scores = _.get(dynamic, "liveData.matchDetails.scores");
  const cards = _.get(dynamic, "liveData.card");
  const substitutes = _.get(dynamic, "liveData.substitute");
  const goals = _.get(dynamic, "liveData.goal");

  const matchDetails = _.get(dynamic, "liveData.matchDetails");
  const matchStatus = _.get(matchDetails, "matchStatus");

  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""} side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock>
        <Backgrounds bg1={backgroundImage} loop={true} />
        {/*<WcBgCircle />*/}

        <video
          className={"country-map-video"}
          controls={false}
          autoPlay={false}
          muted={true}
          loop={false}
        >
          <source
            src={
              lng === "de" ? assets.germanStadiumsDe : assets.germanStadiumsEn
            }
          />
        </video>

        <div className={"wc-content wc-content-v2"}>
          <ProgressBar height={"8px"} />
          <div className={"wc-bg-content"}></div>
          <div className={"left-block-side"}>
            <div className={"header-left green-glow"}>Euro 2024</div>
            <div className={"competition-positioner"}>
              <div className={"competition-logo-container"}>
                <Image
                  src={`/images/dynamic/soccer/competition/${competitionId}.svg`}
                />
              </div>
            </div>
          </div>

          <div className={"country-map"}></div>

          <div className={"header-right"}>{t("Venues")}</div>
        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `background_1920`);
};

export default Index;
